/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { Dropdown1, useThemeMode } from '../../../_metronic/partials'
import { getCSS, getCSSVariableValue } from '../../../_metronic/assets/ts/_utils'
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers'
import { formatNumber } from '../../../reusable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import Select, { CSSObjectWithLabel } from 'react-select'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLocation } from 'react-router-dom'

type Props = {
  className: string
  data: { name: string; data: number[] }[]
  categories: string[]
  totalRevenue: string
  sendData?: any
  length?: any
}

const ChartsWidget9v2: React.FC<Props> = ({
  className,
  data,
  categories,
  totalRevenue,
  sendData,
  length,
}) => {
  let t = Tr()  

  const chartRef = useRef<HTMLDivElement | null>(null)
  const location = useLocation()
  const { mode } = useThemeMode()
  const [selectedFromYear, setSelectedFromYear] = useState('') as any
  const [selectedToYear, setSelectedToYear] = useState('') as any
  const [clear, setClear] = useState('') as any

  useEffect(() => {
    setSelectedToYear('')
    setSelectedFromYear('')
  }, [clear])

  const currentYear = new Date().getFullYear()
  const yearList = Array.from({ length: currentYear - 2020 + 1 }, (_, i) => ({
    value: (currentYear - i).toString(),
    label: (currentYear - i).toString(),
  }))

  useEffect(() => {
    const chart = refreshChart()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, data, categories])

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))
    const chart = new ApexCharts(chartRef.current, getChartOptions(height, data, categories, location))
    if (chart) {
      chart.render()
    }

    return chart
  }

  return (
    <>
      {location.pathname != "/dashboard" ? <div className='d-flex flex-wrap justify-content-center gap-4 mb-5' style={{ zIndex: '100' }}>
        <Select
          name='fromYear'
          id='fromYear'
          placeholder={t('From Year')}
          isSearchable={true}
          options={yearList}
          value={selectedFromYear}
          onChange={(e: any) => {
            setSelectedFromYear(e)
          }}
          menuPortalTarget={document.body} // Ensures the dropdown is rendered at the top level
          styles={{
            menuPortal: (base:CSSObjectWithLabel) => ({ ...base, zIndex: 9999 }), // Highest z-index
            menu: (base :CSSObjectWithLabel) => ({ ...base, zIndex: 9999 }),
          }}
        />

        <Select
          name='toYear'
          id='toYear'
          placeholder={t('To Year')}
          isSearchable={true}
          options={yearList}
          value={selectedToYear}
          onChange={(e: any) => setSelectedToYear(e)}
          menuPortalTarget={document.body} // Ensures the dropdown is rendered at the top level
          styles={{
            menuPortal: (base:CSSObjectWithLabel) => ({ ...base, zIndex: 9999 }), // Highest z-index
            menu: (base :CSSObjectWithLabel) => ({ ...base, zIndex: 9999 }),
          }}
        />

        <button
          className='btn btn-success'
          onClick={() =>
            sendData
              ? sendData({
                fromYear: selectedFromYear.value,
                toYear: selectedToYear.value,
              })
              : ''
          }
        >
          {t("Apply")}
        </button>

        <button
          className='btn btn-danger'
          onClick={() => {
            setSelectedFromYear('')
            setSelectedToYear('')
            setClear(1)
            sendData &&
              sendData({
                fromYear: '',
                toYear: '',
              })
          }}
        >
          {t("Clear")}
        </button>
      </div> : ""}
      <div className={`card ${className} position-relative`}>
        <img
          src={toAbsoluteUrl('/media/otherSVG/Group148.svg')}
          className='position-absolute top-0 end-0'
          style={{ zIndex: 0 }}
          alt='style card'
        />

        <div className='card-header border-0 pt-5' style={{ zIndex: 1 }}>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1 d-flex align-items-center'>
              <FontAwesomeIcon icon={faCircleCheck} className='fontsize35px me-3 themeGreenColor' />
              <span className='fs-3 fw-bold'>{t("Total Revenue")}</span>
            </span>
          </h3>

          <label className='fontsize48px fontweight700 w-100 themeBlueColor'>
            {length == '0' ? '0' : formatNumber(parseFloat(totalRevenue))}
          </label>
        </div>

        {length != '0' ? (
          <div className='card-body '>
            <div
              ref={chartRef}
              id='kt_charts_widget_1_chart'
              className='mt-10'
              style={{ height: '350px' }}
            />
          </div>
        ) : (
         <>
         {location.pathname != "/dashboard" ?  <div className='d-flex justify-content-center align-items-center'>
            <h1 className='mt-10'>
              {selectedFromYear.value != '' ? selectedFromYear.value : ''} {' - '}{' '}
            </h1>
            <h1 className='mt-10'>{selectedToYear.value != '' ? selectedToYear.value : ''} </h1>
            <h1 className='mt-10'> {t("Doesn't Have Any Bookings")} </h1>
          </div>  :""}
         </>
        )}
      </div>
    </>
  )
}

export { ChartsWidget9v2 }

function getChartOptions(
  height: number,
  data: { name: string; data: number[] }[],
  categories: string[],
  location: any
): ApexOptions {
  const labelColor = getCSSVariableValue('--bs-gray-500')
  const borderColor = getCSSVariableValue('--bs-gray-200')
  const baseColor = getCSSVariableValue('--greencolorprofit')
  const secondaryColor = getCSSVariableValue('--greencolorrevenue')


  return {
    series: data,
    chart: {
      fontFamily: 'inherit',
      type: 'bar',
      height: height,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '30%',
        borderRadius: 5,
      },
    },
    legend: {
      show: true, // Enable the legend
      position: 'bottom', // Position it below the chart
      horizontalAlign: 'center',
      markers: {
        width: 12,
        height: 12,
        radius: 12,
      },
      labels: {
        colors: labelColor,
        useSeriesColors: true,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 5,
      },
      onItemClick: {
        toggleDataSeries: false, // Disable clicking on the legend to hide/show series
      },
      onItemHover: {
        highlightDataSeries: false, // Disable highlighting on hover
      },
    },

    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    xaxis: {
      categories: categories,
      axisBorder: { show: false },
      axisTicks: { show: false },
      labels: {
        show: true, // 👈 hide labels on /dashboard
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: labelColor,
          fontSize: '12px',
        },
        formatter: function (val) {
          return val.toFixed(2)
        },
      },
    },
    fill: {
      opacity: 1,
    },
    states: {
      normal: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      hover: {
        filter: {
          type: 'none',
          value: 0,
        },
      },
      active: {
        allowMultipleDataPointsSelection: false,
        filter: {
          type: 'none',
          value: 0,
        },
      },
    },
   tooltip: {
  enabled: true,
  x: {
    show: location.pathname !== '/dashboard', // 👈 disable x value (like 2025) on /dashboard
  },
  y: {
    formatter: function (val: any) {
      return formatNumber(parseFloat(val))
    },
  },
  style: {
    fontSize: '12px',
  },
},
    colors: [baseColor, secondaryColor],
    grid: {
      borderColor: borderColor,
      strokeDashArray: 4,
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
  }
}
